'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        width: ', ';\n      '], ['\n        width: ', ';\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
  slidingLabel: _propTypes2.default.bool,
  iconOuter: _propTypes2.default.element,
  theme: _propTypes2.default.object
};
var defaultProps = {
  disabled: false,
  fullWidth: false,
  dense: false,
  bordered: false,
  colorScheme: 'neutral',
  labelPosition: 'top',
  slidingLabel: false,
  iconOuter: null
};
/** PROP RECEIVERS */

var labelBase = function labelBase(_ref) {
  var labelPosition = _ref.labelPosition,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      path = theme.reactackle.components.textfield.label,
      source = labelPosition === 'top' ? path.positionTop : path.positionSide;
  var fontSize = source.fontSize,
      lineHeight = source.lineHeight,
      textTransform = source.textTransform,
      fontWeight = source.fontWeight;
  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';text-transform:', ';font-weight:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, textTransform, fontWeight, labelPosition === 'side' ? '\n        flex-direction: column;\n        justify-content: center;\n      ' : 'align-items: center;');
};

var labelSpacing = function labelSpacing(_ref2) {
  var labelPosition = _ref2.labelPosition,
      dense = _ref2.dense,
      fullWidth = _ref2.fullWidth,
      bordered = _ref2.bordered,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
      textfieldStyleKey = bordered ? 'bordered' : 'underlined';
  var path = theme.reactackle.components.textfield.label[key].size[textfieldStyleKey];
  var source = null;
  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;else source = path;
  var labelSpacing = (0, _reactackleCore.getValueString)(source.labelSpacing);
  return labelPosition === 'top' ? 'padding-bottom: ' + labelSpacing + ';' : 'margin-right: ' + labelSpacing + ';';
};

var labelStyle = function labelStyle(_ref3) {
  var themeFromProvider = _ref3.theme,
      disabled = _ref3.disabled,
      colorScheme = _ref3.colorScheme,
      labelPosition = _ref3.labelPosition,
      focus = _ref3.focus;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
      path = theme.reactackle.components.textfield.label[key].style;
  var source = null;

  if (!disabled) {
    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
  } else {
    source = path.disabled;
  }

  return 'color: ' + source.fontColor + ';';
};

var labelSideWidth = function labelSideWidth(_ref4) {
  var labelPosition = _ref4.labelPosition,
      themeFromProvider = _ref4.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      source = theme.reactackle.components.textfield.label.positionSide;
  var breakpoints = source.breakpoints.map(function (item) {
    var width = (0, _reactackleCore.getValueString)(item.width);
    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, width));
  });
  return labelPosition === 'side' && (0, _styledComponents.css)(['width:', ';', ';'], (0, _reactackleCore.getValueString)(source.width), breakpoints);
};

var offset = function offset(_ref5) {
  var themeFromProvider = _ref5.theme,
      bordered = _ref5.bordered,
      labelPosition = _ref5.labelPosition,
      dense = _ref5.dense,
      fullWidth = _ref5.fullWidth,
      iconOuter = _ref5.iconOuter;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      styleKey = bordered ? 'bordered' : 'underlined',
      positionKey = labelPosition === 'side' ? 'positionSide' : 'positionTop',
      textfieldPath = theme.reactackle.components.textfield.textfield,
      iconPath = theme.reactackle.components.textfield.iconOuter;
  var labelPath = theme.reactackle.components.textfield.label[positionKey].size[styleKey];
  var textfieldSource = null,
      labelSource = null,
      iconSource = null;

  if (dense && !fullWidth) {
    textfieldSource = textfieldPath.size.dense;
    labelSource = labelPath.dense;
    iconSource = iconPath.size.dense;
  } else if (dense && fullWidth) {
    textfieldSource = textfieldPath.size.denseFullWidth;
    labelSource = labelPath.denseFullWidth;
    iconSource = iconPath.size.denseFullWidth;
  } else if (!dense && fullWidth) {
    textfieldSource = textfieldPath.size.fullWidth;
    labelSource = labelPath.fullWidth;
    iconSource = iconPath.size.fullWidth;
  } else {
    textfieldSource = textfieldPath.size;
    labelSource = labelPath;
    iconSource = iconPath.size;
  }

  var paddingX = (0, _reactackleCore.getValueString)(textfieldSource.paddingX[styleKey]),
      iconSpacing = (0, _reactackleCore.getValueString)(iconPath.iconSpacing),
      boxSize = (0, _reactackleCore.getValueString)(iconSource.boxSize);
  var _labelSource = labelSource,
      paddingTop = _labelSource.paddingTop,
      paddingBottom = _labelSource.paddingBottom,
      labelSpacing = _labelSource.labelSpacing;
  var padBottom = labelPosition === 'side' ? (0, _reactackleCore.getValueString)(paddingBottom) : (0, _reactackleCore.getValueString)(labelSpacing);
  var iconLeftOffset = iconOuter ? 'calc(' + boxSize + ' + ' + iconSpacing + ')' : 0;
  var fwIconOffset = iconLeftOffset ? 'calc(' + iconLeftOffset + ' + ' + paddingX + ')' : paddingX;
  var leftOffset = fullWidth ? fwIconOffset : paddingX;
  var padLeft = labelPosition === 'side' ? paddingX : leftOffset;
  return fullWidth ? '\n      padding-top: ' + (0, _reactackleCore.getValueString)(paddingTop) + ';\n      padding-bottom: ' + padBottom + ';\n      padding-left: ' + padLeft + ';\n      padding-right: ' + paddingX + ';\n    ' : labelPosition === 'top' && 'padding-left: ' + iconLeftOffset + ';';
};
/** STYLES */


var LabelStyled = exports.LabelStyled = _styledComponents2.default.label.withConfig({
  displayName: 'LabelStyled'
})(['display:flex;user-select:none;', ';', ';', ';', ';', ';', ';'], labelBase, labelStyle, labelSpacing, labelSideWidth, offset, (0, _reactackleCore.transition)('color, font-size'));

LabelStyled.propTypes = propTypes;
LabelStyled.defaultProps = defaultProps;
LabelStyled.displayName = 'LabelStyled';